// extracted by mini-css-extract-plugin
module.exports = {"alert":"Alert_alert__393U3","icon":"Alert_icon__1cl0g","info":"Alert_info__2vca3","success":"Alert_success__60vab","warning":"Alert_warning__3J35I","danger":"Alert_danger__1cITY"};